import React, { useCallback } from 'react';
import { render } from 'storyblok-rich-text-react-renderer';
import { BrevFranOssContent, RichText, ShopContent } from '../../types/cms_shared_types';
import { Button } from '../Common/Button';
import { Modal } from './Modal';

interface ConfirmationDialogProps {
  showModal: boolean;
  setShowModal: (value: boolean) => void;
  onYesCallback: () => void;
  title?: string;
  description?: RichText;
  cmsContent: ShopContent | BrevFranOssContent;
}

export const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  showModal,
  setShowModal,
  onYesCallback,
  title,
  description,
  cmsContent,
}) => {
  const closeModal = () => setShowModal(false);

  const isShopContent = (content: ShopContent | BrevFranOssContent): content is ShopContent => {
    return (content as ShopContent).confirmationDialog !== undefined;
  };

  const isBrevFranOssContent = (content: ShopContent | BrevFranOssContent): content is BrevFranOssContent => {
    return (
      (content as BrevFranOssContent).yesAnswer !== undefined && (content as BrevFranOssContent).noAnswer !== undefined
    );
  };

  const yesText = useCallback((): string => {
    if (isShopContent(cmsContent)) {
      return cmsContent.confirmationDialog.yesButton.toUpperCase();
    }

    if (isBrevFranOssContent(cmsContent)) {
      return cmsContent.yesAnswer.toUpperCase();
    }

    return '';
  }, [cmsContent]);

  const noText = useCallback((): string => {
    if (isShopContent(cmsContent)) {
      return cmsContent.confirmationDialog.noButton.toUpperCase();
    }

    if (isBrevFranOssContent(cmsContent)) {
      return cmsContent.noAnswer.toUpperCase();
    }

    return '';
  }, [cmsContent]);

  return (
    <Modal
      showModal={showModal}
      setShowModal={setShowModal}
      small
      header={<div>{title}</div>}
      content={<div>{render(description)}</div>}
      actions={
        <div className="flex flex-row">
          <div className="">
            <Button filled black text={noText()} onClick={closeModal} />
          </div>
          <div className="ml-auto">
            <Button
              filled
              text={yesText()}
              onClick={() => {
                onYesCallback();
                closeModal();
              }}
            />
          </div>
        </div>
      }
    ></Modal>
  );
};
